import { Injectable } from '@angular/core';
import { initialize, LDClient } from 'ldclient-js';
import { ENV } from '../../environment';
import * as _ from 'lodash';
import { AuthService } from '@yotpo-ui/core';
import { catchError, map, take } from 'rxjs/operators';
import { AccountService } from './account.service';
import { of } from 'rxjs';

interface User {
  key?: string;
  anonymous: boolean;
  custom?: {
    createdAt?: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class LaunchDarklyService {

  private ldClient: LDClient;
  serviceReady: Promise<boolean>;


  constructor(private authService: AuthService,
              private accountService: AccountService) {
    if (!ENV.launchDarklyEnabled || !ENV.launchDarklyClientId) {
      this.serviceReady = Promise.resolve(false);
    } else {
      this.initClient();
    }
  }

  public initClient() {
    this.serviceReady = new Promise(((resolve) => {
      let user: User = { anonymous: true, custom: {} };
      const appkey = this.authService.getCredentials().appKey;
      if (appkey) {
        user.key = appkey;
        user.anonymous = false;
      }
      return this.accountService.getAppData().pipe(
        take(1),
        map((appData) => {
          user.custom.createdAt = appData.response.app.created_at;
          return true;
        }),
        catchError( () => {
          return of(true);
        })
      ).subscribe(() => {
          this.ldClient = initialize(ENV.launchDarklyClientId, user);
          this.ldClient.on('ready', () => {
            resolve(true);
          });
        });
    }));
  }

  changeUser(appKey): Promise<any> {
    if (_.isUndefined(this.ldClient)) {
      return Promise.resolve();
    }

    let anonymous = (appKey === null);
    return this.ldClient.identify({ key: appKey, name: appKey, anonymous: anonymous });
  }

  public getFlagStatus(flagName) {
    return this.getVariation(flagName);
  }

  public getFlagStatusDetail(flagName) {
    if (_.isUndefined(this.ldClient)) {
      return false;
    }

    return this.ldClient.variationDetail(flagName, false);
  }

  public getVariation(flagName) {
    if (_.isUndefined(this.ldClient)) {
      return false;
    }

    return this.ldClient.variation(flagName, false);
  }

  public waitUntilReady(): Promise<void> {
    return this.ldClient.waitUntilReady();
  }
}

